import { Link } from 'react-router-dom'
import './About.css'

import Separator from '../../Components/Separator/Separator'
import SEO from '../../Components/SEO/SEO';
import PageTitle from '../../Hooks/PageTitle';

import developer from '../../Media/About.Media/developer_activity.png'

import arabic from '../../Media/About.Media/Languages.Media/arabic.png'
import frensh from '../../Media/About.Media/Languages.Media/frensh.png'
import english  from '../../Media/About.Media/Languages.Media/english.png'
import german from '../../Media/About.Media/Languages.Media/german.png'
// import spanish from '../../Media/About.Media/Languages.Media/spanish.png'

import fitness from '../../Media/About.Media/Hobbies.Media/fitness.png'
import guitar from '../../Media/About.Media/Hobbies.Media/guitar.png'
import skate from '../../Media/About.Media/Hobbies.Media/skateboard.png'
import movies from '../../Media/About.Media/Hobbies.Media/movies.png'
import sketch from '../../Media/About.Media/Hobbies.Media/sketch.png'
import chess from '../../Media/About.Media/Hobbies.Media/chess.png'


const About = ({ ShowMessage }) => {
    PageTitle('About Me');

	const CopyText = (message, text) => {
		navigator.clipboard.writeText(text)
			.then(() => {
				console.log('Text copied to clipboard:', text);
				ShowMessage(`${message} has been copied to your clipboard.`, 'succeed');
			})
			.catch(err => {
			console.error('Failed to copy text:', err);
		});
	}

	return (
		<>
			<SEO 
                title="About Me"
                description="Learn about my journey in AI and technology. Mathematics and Computer Science graduate pursuing a Master's in Artificial Intelligence at Faculty of Science Semlalia, Marrakech. Passionate about building intelligent systems that solve real-world problems."
                url="https://yassinebazgour.vercel.app/About"
                keywords="About Yassine Bazgour, AI engineer background, computer science education, Morocco AI student, Marrakech developer, Mathematics and CS, Faculty of Science Semlalia, AI journey"
            />
			<section className='about-section'>
				<div className='about-header'>
					<div className='about-header-text-content'>
						<span className='about-header-title'>Innovative Mindset, Passion for Progress</span>
						<div className='about-header-descriptions-container'>
							<span className='about-header-description'>
								Data Scientist, Robotics Engineer, and Full Stack Developer from Marrakesh. I build predictive ML models, integrate them into interactive web apps, and bring them to life in robots. Holding a BSc in Math & CS, and pursuing an AI Master’s.
							</span>
							<span className='about-header-description'>
								I'm also an active member of several university clubs at the faculty of sciences Semlalia, including 
								<span className='club-link' onClick={() => {window.open('https://www.instagram.com/chessclubfssm/', '_blank')}}> Chess Club</span> where 
								we organize tournaments and gather the best  players, 
								the <span className='club-link' onClick={() => {window.open('https://www.instagram.com/robotics.ai.club/', '_blank')}}>RAIC Robotics Club</span>, 
								where I participate in organizing events, showcasing prototypes, and welcoming new members.
							</span>
						</div>
						<div className='about-header-contacts-container'>
							<span className='about-header-contact'>Email: <span onClick={() => {CopyText('Email', 'yassine.bazgour@gmail.com')}} className='about-header-contact-info'>yassine.bazgour@gmail.com</span></span>
							<span className='about-header-contact'>Linkedin: <span onClick={() => {window.open('https://www.linkedin.com/in/yassine-bazgour-178b73305/', '_blank')}} className='about-header-contact-info'>Yassine Bazgour</span></span>
							<span className='about-header-contact'>Github: <span onClick={() => {window.open('https://github.com/DarttGoblin', '_blank')}} className='about-header-contact-info'>DarttGoblin</span></span>
							<span className='about-header-contact'>Resume: <span onClick={() => {window.open('https://drive.google.com/file/d/1pC2vYo9KjBXQzzKBIqBoIqE0rSEYJgE3/view?usp=sharing', '_blank')}} className='about-header-contact-info'>View Resume</span></span>
							<span className='about-header-contact'>ResearchGate: <span onClick={() => {window.open('https://www.researchgate.net/profile/Yassine-Bazgour?ev=hdr_xprf', '_blank')}} className='about-header-contact-info'>View Profile</span></span>
							<span className='about-header-contact'>Kaggle: <span onClick={() => {window.open('https://www.kaggle.com/yassinebazgour', '_blank')}} className='about-header-contact-info'>View Work</span></span>
							<span className='about-header-contact'>Datacareers: <span onClick={() => {window.open('https://www.datacareer.de/resume/18887/ai-engineer/', '_blank')}} className='about-header-contact-info'>View Career</span></span>
							<span className='about-header-contact'>Phone: <span onClick={() => {CopyText('Number phone', '+4915511054410')}} className='about-header-contact-info'>+49 155 1105 4410</span></span>
							{/* <span className='about-header-contact'>Upwork: <span onClick={() => {window.open('https://www.upwork.com/freelancers/~014ea0be5b11a41ad3', '_blank')}} className='about-header-contact-info'>View Account</span></span> */}
						</div>
						<Link 
							to='/Contact'
							onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
						>
							<button className='hire-me'>HIRE ME</button>
						</Link>
					</div>
					<div className='about-header-image-container'>
						<img className='about-header-image' src={developer} alt='just a random picture, nothing interesting!'></img>
					</div>
				</div>
				<Separator/>
				<div className='section about-experiences'>
					<span className='about-experiences-title'>Experiences</span>
					<span className='about-experiences-description'>Experience has shaped my skills more than any classroom ever could.</span>
					<div className='about-experiences-year'>
						<div className='empty'></div>
						<div className='about-experiences-year-separator'>
							<span className='separator-year'><i class='fa fa-briefcase'></i></span>
							<div className='separator-vertical-line'></div>
						</div>
						<div className='about-experiences-achievement right'>
							<span className='achievement-year'>Mar. 2026 - Aug. 2026</span>
							<span className='achievement-title'>AI & Robotics Intern @ <span className='experience-project' onClick={() => {window.open('https://www.ruhr-uni-bochum.de/', '_blank')}}>Ruhr University Bochum</span></span>
							<span className='achievement-place'>On-site · Bochum, Germany</span>
						</div>
					</div>
					<div className='about-experiences-year left-year'>
						<div className='about-experiences-achievement left'>
							<span className='achievement-year'>Jul. 2025 - Aug. 2025</span>
							<span className='achievement-title'>AI & Data Intern @ <span className='experience-project' onClick={() => {window.open('https://www.linkedin.com/company/teknologiate/posts/?feedView=all', '_blank')}}>Teknologiate</span></span>
							<span className='achievement-place'>Remote</span>
						</div>
						<div className='about-experiences-year-separator'>
							<span className='separator-year'><i class='fa fa-briefcase'></i></span>
							<div className='separator-vertical-line'></div>
						</div>
						<div className='empty'></div>
					</div>
					<div className='about-experiences-year'>
						<div className='empty'></div>
						<div className='about-experiences-year-separator'>
							<span className='separator-year'><i class='fa fa-briefcase'></i></span>
							<div className='separator-vertical-line'></div>
						</div>
						<div className='about-experiences-achievement right'>
							<span className='achievement-year'>Apr. 2025 - Jun. 2025</span>
							<span className='achievement-title'>Research Assistant @ Prof. <span className='experience-project' onClick={() => {window.open('https://www.linkedin.com/in/mohamed-amine-chadi-%F0%9F%87%B5%F0%9F%87%B8-179baa115/', '_blank')}}>Mohamed Amine Chadi</span></span>
							<span className='achievement-place'>On-site · Marrakech, Morocco </span>
						</div>
					</div>
					<div className='about-experiences-year left-year'>
						<div className='about-experiences-achievement left'>
							<span className='achievement-year'>Nov. 2024 - Mar. 2025</span>
							<span className='achievement-title'>Freelance Web Dev @ <span className='experience-project' onClick={() => {window.open('https://heatz.ma/', '_blank')}}>Heatz</span></span>
							<span className='achievement-place'>Remote - Team of 2</span>
						</div>
						<div className='about-experiences-year-separator'>
							<span className='separator-year'><i class='fa fa-briefcase'></i></span>
							<div className='separator-vertical-line'></div>
						</div>
						<div className='empty'></div>
					</div>
					<div className='about-experiences-year'>
						<div className='empty'></div>
						<div className='about-experiences-year-separator'>
							<span className='separator-year empty-year'>2023</span>
						</div>
						<div className='empty-year-placeholder'></div>
					</div>
				</div>
				<Separator/>
				<div className='section about-education'>
					<span className='about-education-title'>Education</span>
					<span className='about-education-description'>My education has taught me a lot, but I've learned even more beyond it.</span>
					<div className='about-education-year'>
						<div className='empty'></div>
						<div className='about-education-year-separator'>
							<span className='separator-year'><i className='fa fa-graduation-cap'></i></span>
							<div className='separator-vertical-line'></div>
						</div>
						<div className='about-education-achievement right'>
							<span className='education-achievement-year'>Sep. 2024 - Sep. 2026</span>
							<span className='education-achievement-title'>Master's Degree in Artificial Intelligence</span>
							<span className='education-achievement-place'>Faculty of Science Semlalia | Marrakesh</span>
						</div>
					</div>
					<div className='about-education-year left-year'>
						<div className='about-education-achievement left'>
							<span className='education-achievement-year'>Sep. 2021 - Sep. 2024</span>
							<span className='education-achievement-title'>Bachelor's Degree in Fundamental Studies in Math & Computer Sci.</span>
							<span className='education-achievement-place'>Faculty of Science Semlalia | Marrakesh</span>
						</div>
						<div className='about-education-year-separator'>
							<span className='separator-year'><i className='fa fa-graduation-cap'></i></span>
							<div className='separator-vertical-line'></div>
						</div>
						<div className='empty'></div>
					</div>
					{/* <div className='about-education-year'>
						<div className='empty'></div>
						<div className='about-education-year-separator'>
							<span className='separator-year'><i className='fa fa-graduation-cap'></i></span>
							<div className='separator-vertical-line'></div>
						</div>
						<div className='about-education-achievement right'>
							<span className='achievement-year'>September 2023</span>
							<span className='achievement-title'>DEUG in Mathematics and Computer Science</span>
							<span className='achievement-place'>Faculty of Science Semlalia | Marrakesh</span>
						</div>
					</div>
					<div className='about-education-year'>
						<div className='empty'></div>
						<div className='about-education-year-separator'>
							<span className='separator-year empty-year'>2022</span>
							<div className='separator-vertical-line'></div>
						</div>
						<div className='empty-year-placeholder'></div>
					</div>
					<div className='about-education-year'>
						<div className='empty'></div>
						<div className='about-education-year-separator'>
							<span className='separator-year empty-year'>2021</span>
							<div className='separator-vertical-line'></div>
						</div>
						<div className='empty-year-placeholder'></div>
					</div>
					<div className='about-education-year left-year'>
						<div className='about-education-achievement left'>
							<span className='achievement-year'>September 2020</span>
							<span className='achievement-title'>Baccalaureate in Mathematics and Engineering Science Option Frensh</span>
							<span className='achievement-place'>High School Mohammed V | Essaouira</span>
						</div>
						<div className='about-education-year-separator'>
							<span className='separator-year'><i className='fa fa-graduation-cap'></i></span>
							<div className='separator-vertical-line'></div>
						</div>
						<div className='empty'></div>
					</div> */}
					<div className='about-education-year'>
						<div className='empty'></div>
						<div className='about-education-year-separator'>
							<span className='separator-year empty-year'>2023</span>
						</div>
						<div className='empty-year-placeholder'></div>
					</div>
				</div>
				<Separator/>
				<div className='section about-work-flow-container'>
					<span className='about-work-flow-title'>Metrics Snapshot</span>
					<span className='about-work-flow-description'>It ain't much, but its honest work</span>
					<div className='about-work-flow'>
						<div className='work-flow-row'>
							<div className='work-flow'>
								<i className='fas fa-clock work-flow-icon'></i>
								<div className='work-flow-separator'></div>
								<div className='work-flow-text-content'>
									<span className='work-flow-title'>+500</span>
									<span className='work-flow-description'>Hours Worked</span>
								</div>
							</div>
							<div className='work-flow'>
								<i className='fas fa-layer-group work-flow-icon'></i>
								<div className='work-flow-separator'></div>
								<div className='work-flow-text-content'>
									<span className='work-flow-title'>+30</span>
									<span className='work-flow-description'>Projects Finished</span>
								</div>
							</div>
						</div>
						<div className='work-flow-row'>
							<div className='work-flow'>
								<i className='fas fa-smile work-flow-icon'></i>
								<div className='work-flow-separator'></div>
								<div className='work-flow-text-content'>
									<span className='work-flow-title'>1</span>
									<span className='work-flow-description'>Happy Client</span>
								</div>
							</div>
							<div className='work-flow'>
								<i className='fas fa-coffee work-flow-icon coffe-icon'></i>
								<div className='work-flow-separator coffe-separator'></div>
								<div className='work-flow-text-content'>
									<span className='work-flow-title'>69</span>
									<span className='work-flow-description'>Coffee Drank</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<Separator/>
				<div className='section about-languages'>
					<span className='languages-title'>Languages</span>
					<span className='languages-description'>
						Different languages, one global conversation.
					</span>
					<div className='languages-container'>
						<div className='language-container'>
							<img className='language-image' src={arabic} alt='Arabic Flag'></img>
							<span className='language-title'>Arabic</span>
							<span className='language-description'>
								Native
								<br/>.
							</span>
						</div>
						<div className='language-container'>
							<img className='language-image' src={english} alt='British Flag'></img>
							<span className='language-title'>English</span>
							<span className='language-description'>
								Advanced<br/><span className='language-link' onClick={() => window.open('https://cert.efset.org/en/Vwnxgt', '_blacnk')}>C1 🔗</span>
							</span>
						</div>
						<div className='language-container'>
							<img className='language-image' src={frensh} alt='France Flag'></img>
							<span className='language-title'>Frensh</span>
							<span className='language-description'>
								Advanced<br/> C1
							</span>
						</div>
						<div className='language-container'>
							<img className='language-image' src={german} alt='Germany Flag'></img>
							<span className='language-title'>German</span>
							<span className='language-description'>
								Beginner<br/><span className='language-link' onClick={() => window.open('https://drive.google.com/file/d/1wNXoPbDUF3uxp6yPJs3C0q4rJZDXi6bw/view?usp=sharing', '_blacnk')}>A1 🔗</span>
							</span>
						</div>
						{/* <div className='language-container'>
							<img className='language-image' src={spanish} alt='Spanish Flag'></img>
							<span className='language-title'>Spanish</span>
							<span className='language-description'>
								Beginner<br/> A1 
							</span>
						</div> */}
					</div>
				</div>
				<Separator/>
				<div className='section github-stats-container'>
					<span className='github-stats-title'>Github Stats</span>
					<span className='github-stats-description'>
						Most of my work happens in private repositories.<br />
						The graph doesn't show the full story.
					</span>
					<div className='github-stats-images-container'>
						<div className='github-stats-image-container'>
							<span className='github-stats-image-label'>GitHub Contributions</span>
							<img 
								className='github-stats-image'
								src="https://ghchart.rshah.org/000000/DarttGoblin" 
								alt="Stats can take longer to load, or could be an error, try to refresh"
								onError={(e) => e.target.style.display = 'none'}
							/>
						</div>
					</div>
				</div>
				<Separator/>
				<div className='section about-hobbies'>
					<span className='hobbies-title'>Hobbies</span>
					<span className='hobbies-description'>
						These are the activities that bring me joy and help me unwind, balancing<br/>
						my passion for technology with personal growth.
					</span>
					<div className='hobbies-container'>
						<div className='hobby-container'>
							<img className='hobby-image' src={fitness} alt='Fitness'></img>
							<span className='hobby-title'>Fitness</span>
							<span className='hobby-description'>
								As a bodybuilder for over 6 years, fitness has taught me discipline, and 
								perseverance in both physical and mental challenges.
							</span>
						</div>
						<div className='hobby-container'>
							<img className='hobby-image' src={guitar} alt='Guitar'></img>
							<span className='hobby-title'>Guitar</span>
							<span className='hobby-description'>
								Playing the guitar has been a passion of mine for over 2 years. It helps me relax and 
								express creativity through music.
							</span>
						</div>
						<div className='hobby-container'>
							<img className='hobby-image' src={skate} alt='Skate'></img>
							<span className='hobby-title'>Skating</span>
							<span className='hobby-description'>
								Skating for 6 years has been my way of staying active, mastering balance, 
								and occasionally pretending I'm cool while dodging curbs.
							</span>
						</div>
						<div className='hobby-container'>
							<img className='hobby-image' src={movies} alt='Movies'></img>
							<span className='hobby-title'>Movies</span>
							<span className='hobby-description'>
								I enjoy analyzing movie plots and characters, drawing inspiration from storytelling to fuel my creativity and imagination.
							</span>
						</div>
						<div className='hobby-container'>
							<img className='hobby-image' src={sketch} alt='Sketching'></img>
							<span className='hobby-title'>Sketching</span>
							<span className='hobby-description'>
								Sketching allows me to express ideas visually. I especially enjoy sketching the design of my projects during early concept stages.
							</span>
						</div>
						<div className='hobby-container'>
							<img className='hobby-image' src={chess} alt='Chess'></img>
							<span className='hobby-title'>Chess</span>
							<span className='hobby-description'>
								Chess sharpens my strategic thinking and decision-making, helping me stay focused and composed while solving complex problems.
							</span>
						</div>
					</div>
				</div>
			</section>
		</>
	)
}

export default About